import React from 'react'
import PropTypes from 'prop-types'
import ReactTextareaAutocomplete from '@webscopeio/react-textarea-autocomplete'

import ResizableTextarea, {
  ResizableTextareaWithRefForwarding,
} from './ResizableTextarea'
import emojiTrigger from './Emoji/trigger'
import AutocompleteLoader from './AutocompleteLoader'

const Textarea = ({hasEmojiAutoComplete, ...props}) => {
  if (!hasEmojiAutoComplete) return <ResizableTextarea {...props} />

  return (
    <ReactTextareaAutocomplete
      textAreaComponent={ResizableTextareaWithRefForwarding}
      loadingComponent={AutocompleteLoader}
      minChar={0}
      trigger={emojiTrigger}
      dropdownClassName="dropdown-menu is-block"
      itemClassName="dropdown-item has-cursor-pointer"
      listClassName="dropdown-content"
      {...props}
    />
  )
}

Textarea.defaultProps = {
  hasEmojiAutoComplete: false,
}

Textarea.propTypes = {
  hasEmojiAutoComplete: PropTypes.bool,
}

export default Textarea
